import React from 'react';
import LeadCapture from '../leadCapture/LeadCapture';

function AdvertiseUs() {
  return (
    <div>
      <LeadCapture source="advertise-with-us" />
    </div>
  );
}

export default AdvertiseUs;
